import React, { Fragment } from "react";

const CriterialsDescriptions = ({ }) => {

    return (
        <Fragment>
            <div>
                <h4 className="text-center">Criterios</h4>
                <br />
                <li>
                    <b>Optimo (0%)</b>NO HUBO RESULTADOS RECHAZADOS 
                </li>
                <li>
                    <b>DESEADO (3%)</b>HUBO MENOS DE 3% EN LOS RESULTADOS RECHAZADOS
                </li>
                <li>
                    <b>MINIMO (5%)</b>HUBO MAS DEL 5% Y SE REQUIERE UN PLAN DE MEJORAMIENTO
                </li>
            </div>
        </Fragment>
    );
}
export default CriterialsDescriptions;